import { StickyDirection } from '@angular/cdk/table';
import { Injectable,Component } from '@angular/core';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class preSocialReservationInfo {
    StudentID :number;
    SocialReservationID:number;
    SocialReservationShortName:string;
    SocialReservationName:string;
    checkedValue:string;
    SocialReservationIDValue:string;
    UpdatedLoginID :number;
    chk:boolean;
    SocialReservationStatusFlag:string;
}
export class EducationalStream {
  EducationalStreamID:number;
  EducationalStreamName:string;
  AddInfo:string;
}
let educationaldetails: preSocialReservationInfo[] = [
  {
    StudentID :0,
    SocialReservationID:0,
    SocialReservationShortName:"",
    SocialReservationName:"",
    checkedValue:"",
    SocialReservationIDValue:"",
    UpdatedLoginID :0,
    chk:false,
    SocialReservationStatusFlag:""
  }
];


@Injectable( {  
  providedIn: 'root'  
})
@Component({
  providers: [DataAccessService]
})

export class SocialreservationService {

  constructor(private dataService: DataAccessService) {
   
  }
  public save(data) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'PostUpdatePreStudentSocialReservation'; // setting method name from API controller.
    return this.dataService.add<preSocialReservationInfo[]>(data) 
  }
  public update(data) {
    this.dataService.setControllerName = '/PreStudentOtherInfo/';
    this.dataService.setMethodName = 'PostPreStudentOtherInfo'; // setting method name from API controller.
    return this.dataService.add<preSocialReservationInfo[]>(data)
  }
  public GetContactinfo(StudentID) {
    this.dataService.setControllerName = '/PreStudentAddressInfo/';
    this.dataService.setMethodName = 'GetPreStudentAddressInfoList?StudentID='+ StudentID + ""; // setting method name from API controller.
    return this.dataService.getAll<preSocialReservationInfo[]>()
  } 
  public GetEducationalStream() {
    this.dataService.setControllerName = '/BasicEducationalStream/';
    this.dataService.setMethodName = 'GetBasicEducationalStreamList?EducationalStreamID=0'; // setting method name from API controller.
    return this.dataService.getAll<EducationalStream[]>()
  }
  public GetSocialReservationInfo(StudentID) {
    this.dataService.setControllerName = '/PreStudentInformation/';
    this.dataService.setMethodName = 'GetSocialReservationByStudentID?StudentID=' + StudentID + ''; // setting method name from API controller.
    return this.dataService.getAll<preSocialReservationInfo[]>()
  }

  /* addEducationalDetails(data: preSocialReservationInfo) {
    data.StudentOtherInfoID = educationaldetails.length + 1;
    educationaldetails.push(data);
  } */
  saveEducationalDetails(data: preSocialReservationInfo) {

  }
  deleteEducationalDetails(data: preSocialReservationInfo) {
    
  }
}
